/**
 * Every user-facing Gigs string. English only, on purpose: the home cards
 * around Gigs are English, and the Hindi `t()` fallback read oddly here, so
 * Gigs does not go through the localization bundles.
 */
export const GIGS_COPY = {
  navTitle: "Gigs",
  historyNavTitle: "History",
  status: {
    onDuty: "On duty",
    off: "Off",
    // Open days and closed-unanswered days read the same; the dot colour
    // tells them apart.
    pending: "Not marked",
    notMarked: "Not marked",
  },
  home: {
    title: "Gigs",
    subtitle: (window: number) => `Mark the next ${window} days`,
  },
  date: {
    today: "Today",
    tomorrow: "Tomorrow",
  },
  marking: {
    heading: (window: number) => `Working the next ${window} days?`,
    notMarkedYet: "Not marked yet",
    yes: "Yes",
    no: "No",
    // Only shown while the server sends a lock_time (the cutoff is off for
    // now, so it sends null and just the no-show line shows).
    footerWithTime: (time: string) =>
      `Change until ${time}. Marking yes and not showing up counts as a no-show.`,
    footerNoTime: "Marking yes and not showing up counts as a no-show.",
    summary: (yes: number, no: number, pending: number) =>
      `${yes} yes · ${no} no · ${pending} pending`,
    confirm: "Confirm",
    submitting: "Submitting…",
    retry: "Retry",
    loadError: "Couldn't load your Gigs schedule.",
  },
  confirmation: {
    title: "Availability confirmed",
    subtitle: "The store can now see your answer.",
    // Only shown while the server sends a lock_time.
    captionWithTime: (time: string) =>
      `You can change it until ${time} the day before.`,
    skippedSingular: "1 day had already closed, so it kept its saved answer.",
    skippedPlural: (count: number) =>
      `${count} days had already closed, so they kept their saved answers.`,
    change: "Change",
    gotIt: "Got it",
  },
  history: {
    title: "History",
    subtitle: "What you marked vs what you worked",
    markedYes: "Days marked yes",
    worked: "Worked",
    noShow: "No-show",
    loadError: "Couldn't load your Gigs history.",
    retry: "Retry",
    legendUpcomingYes: "Upcoming yes",
    legendMarkedYes: "Marked yes",
    legendWorked: "Worked",
    legendNoShow: "No-show",
    legendOff: "Off",
    legendNotMarked: "Not marked",
  },
} as const;
